import { DEFAULT_CONTAINER_WIDTH } from '@aytm/app/stats/page/question-views/mn/components/menu-section/chart/lib/constants'
import { CHART_PLACEHOLDER_HEIGHT } from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'

// the menu image's final on-screen height is known from the schema, so placeholders sized
// with it never jump when the image arrives; a measured width overrides the column default
export const calcMenuChartHeight = (image, containerWidth = DEFAULT_CONTAINER_WIDTH) => {
  const { width, height } = image?.original || {}
  if (!width || !height) return CHART_PLACEHOLDER_HEIGHT

  return Math.round(height * Math.min(1, containerWidth / width))
}
